exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unsubscribe-container .subscription-data{color:#5a5a5a;background:#ccc;border:1px solid #ccc;padding:8px;border-radius:5px}.unsubscribe-container .subscription-data.success{background:rgba(0,255,0,.1);border:1px solid rgba(0,255,0,.2)}.unsubscribe-container .subscription-data .data{padding-left:8px}.unsubscribe-container .subscription-data .label{font-weight:700}.unsubscribe-container .subscription-data .label:after{content:\":\"}.unsubscribe-container .unsubscribe-desc{margin:16px 4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/unsubscribe/unsubscribe.scss
// module id = 144
// module chunks = 0